import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Post } from '../web_api/api'
import '../branch/branch.css'

export default function CmsTreatmentCreate() {
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [image, setImage] = useState(null)

    const handleImage = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0])
        }
    }

    const create = async () => {
        const formData = new FormData()
        formData.append('name', name)
        formData.append('description', description)
        formData.append('image', image)
        await Post('/cms-treatment-types', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <Link to='/cms-treatment'>Treatment Types</Link>
                <span className='separator'>›</span>
                <span className='current'>Create Treatment Type</span>
            </div>

            <div className='branch-page-title'>Create Treatment Type</div>
            <div className='branch-page-subtitle'>Add a new treatment type</div>

            <div className='branch-card'>
                <div className='branch-card-body'>
                    <div className='branch-form-grid'>
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>General Information</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='name'>Name</label>
                                    <input type='text' id='name' placeholder='Treatment Type Name' className='branch-input' value={name} onChange={(e) => setName(e.target.value)} />
                                </div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='desc'>Description</label>
                                    <textarea id='desc' placeholder='Write description ...' className='branch-input' value={description} onChange={(e) => setDescription(e.target.value)} />
                                </div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='img'>Image</label>
                                    <input type='file' id='img' className='branch-input' onChange={handleImage} />
                                    {image && (
                                        <div className='mt-3 mb-2'>
                                            <img
                                                src={URL.createObjectURL(image)}
                                                className='mt-2'
                                                style={{ width: '100%', maxWidth: '300px', height: '200px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #ddd' }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='branch-form-footer'>
                        <Link to='/cms-treatment' className='branch-btn branch-btn-outline'>Cancel</Link>
                        <button className='branch-btn branch-btn-primary' onClick={create}>Create</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
